<template>
  <header class="">
    
    <nav class="navbar navbar-expand-md d-none d-md-flex navbar-top" :class="{ 'bg-dark text-white': isProfileSection }">

      <div class="container py-1">
        <div class="d-flex align-items-center justify-content-between w-100">
          <router-link :to="{ name: 'profile' }" class="navbar-brand" rel="home" title="" itemprop="url">
            <img v-if="isProfileSection" class="d-inline-block align-top mr-3" src="/static/images/logo.svg" width="94" alt="Izuchai.com">
            <img v-else class="d-inline-block align-top mr-3" src="/static/images/logo_dark.svg" width="94" alt="Izuchai.com">
          </router-link>
      
          <ul>
            <li><router-link :to="{ name: 'profile' }" class="router-link" v-if="user && user.isStudent">Мой профиль</router-link></li>
            <li><router-link :to="{ name: 'subjects' }" class="router-link" v-if="user && user.isStudent" :class="{ 'router-link-exact': isSubjectSection }">Предметы</router-link></li>
            <li><router-link v-if="user && user.isAdmin" :to="{ name: 'admin-subjects' }" class="router-link" :class="{ 'router-link-exact': isAdminSection }">Администратор</router-link></li>
          </ul>

          <div class="text-right" v-if="!isLogged">
            <ul>
              <li>
                <router-link :to="{ name: 'login' }">Войти</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'register' }">Зарегистрироваться</router-link>
              </li>
            </ul>
          </div>
          <div class="text-right" v-else>
            <ul>
              <li>
                <a class="" href="#" @click.prevent="logout()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                Выйти</a>
              </li>
            </ul>
          </div>
        </div>
      </div><!-- .container -->

    </nav><!-- .site-navigation -->

    <nav class="d-md-none py-2 navbar bg-dark text-white text-center">
      <a class="text-center w-100 mt-2 mb-4" rel="home" href="<?php echo esc_url( home_url( '/' ) ); ?>" title="" itemprop="url">
        <img width="94" src="/static/images/logo.svg" alt="Izuchai.com">
      </a>
      <div class="w-100">
      </div>
    </nav>

  </header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'app-header',
  data () {
    return {
      showAccountModal: false
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('LOGOUT')
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isLogged () {
      if (this.$store.state.auth.user) {
        return this.$store.state.auth.user.id
      }
    },
    isProfileSection () {
      return this.$route.name.startsWith('profile')
    },
    isSubjectSection () {
      return this.$route.name.startsWith('purchased-subject') || this.$route.name.startsWith('subject')
    },
    isAdminSection () {
      return this.$route.name.startsWith('admin')
    }
  },
  watch: {
    '$route' () {
      this.$bvModal.hide('header-modal')
    }
  }
}
</script>